import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './LoginPopupForm.html?raw';
import topic from 'dojo/topic';
import FloatingContainer from '../../moreCore/UI/Floating/FloatingContainer';
import "../../moreCore/UI/Floating/FloatingContainer";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import SessionInfo from '../../moreCore/System/Session/SessionInfo';


class LoginPopupForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    targetNode: HTMLElement = null;
    private sectionDeveloper: HTMLElement;
    private headingTxt: HTMLElement;
    private btnLogout: HTMLElement;
    private floatingContainer: any = null;
    private isShown: boolean = false;
    private sessionInfo: MdsLax<InstanceType<typeof SessionInfo>> = null;

    show() {
        if (!this.targetNode) {
            this.targetNode = document.getElementById("top_login_info");

            if (!this.targetNode) {
                alert("missing node in layout: #top_login_info");
                return;
            }
        }

        on(this.targetNode, "mouseleave", lang.hitch(this, this._onMouseLeave));
        on(this.targetNode, "mouseenter", lang.hitch(this, this._onMouseEnter));

        this.UiModder.domStyle.set(this.domNode, "width", this.targetNode.clientWidth);
        this.UiModder.domClass.add(this.targetNode, "popupActive");

        let floatingContainer = new FloatingContainer();
        floatingContainer.on("close", lang.hitch(this, this._onClose_FloatingContainer));
        //on(floatingContainer, "close", lang.hitch(this, this._onClose_FloatingContainer))
        floatingContainer.setContent(this.domNode);

        floatingContainer.open(this.targetNode, null, false, true);

        this.isShown = true;
        this.floatingContainer = floatingContainer;
    }

    close() {

        if (this._closeDelayHandle) {
            clearTimeout(this._closeDelayHandle);
            this._closeDelayHandle = null;
        }

        this.floatingContainer.close();
        this.UiModder.domClass.remove(this.targetNode, "popupActive");
    }

    private _closeDelayHandle: any = null;

    private _onMouseLeave(evt) {
        this._closeDelayHandle = setTimeout(lang.hitch(this, this.close), 3000);
    }

    private _onMouseEnter(evt) {
        if (this._closeDelayHandle) {
            clearTimeout(this._closeDelayHandle);
            this._closeDelayHandle = null;
        }
    }

    private setContentFromSession(): void {
        if (this.sessionInfo) {

            this.headingTxt.innerHTML = this.sessionInfo.sessionData.UserDisplayName;
        }
    }

    private _onClose_FloatingContainer() {
        this.isShown = false;
        (window as any).loginPopupForm = null;

        this.UiModder.domClass.remove(this.targetNode, "popupActive");
    }

    private _onClick_Login(evt: MouseEvent) {
        this.show();
    }

    private _onClick_Logout(evt: MouseEvent) {
        this.UiModder.domClass.add(this.btnLogout, "w3-disabled");

        this.UiModder.domClass.add(document.body, "mds-fade");
        setTimeout(lang.hitch(this, this.UiModder.domClass.add, document.body, "hidden"), 10);

        let sessionID = this.sessionInfo.sessionData.Session.Id;

        this.RequestManager.post(window.appRoot + "session/close",
            {
                "sessionid": sessionID
            },
            lang.hitch(this, "_onCloseSessionResponse"),
            lang.hitch(this, "_onCloseSessionError")
        );
    }

    _onCloseSessionResponse(response) {
        topic.publish("/Session/Close", null);

        setTimeout(lang.hitch(this, function () {
            location.reload();
        }), 500);
    }

    private _onCloseSessionError(error: more.requestErrorMessage) {

        this.UiModder.domClass.remove(document.body, "hidden");
        console.error("_onCloseSessionError", error);
        alert(error.Message);

        this.UiModder.domClass.remove(this.btnLogout, "w3-disabled");
    }
    private _onClick_Settings(evt: MouseEvent) {
        location.href = window.appRoot + "home/login";
    }

    private _onClick_ReleaseSessionsBtn(evt: MouseEvent) {
        let url = window.appRoot + "management/ReleaseAllPitSessions";
        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, function (response) { alert(response); }),
            lang.hitch(this, function (error: more.requestErrorMessage) { alert(error.Message); }),
            false // sync
        );
    }
    private _onClick_CurrentXXX(evt: MouseEvent) {

    }

    private _onOpenSession() {
        if (window.sessionInfo) {
            this.sessionInfo = window.sessionInfo;
            this.UiModder.domClass.remove(this.btnLogout, "w3-disabled");
        }
    }
    
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        if (window.sessionInfo) {
            this.sessionInfo = window.sessionInfo;
            this.setContentFromSession();
        } else {
            this.UiModder.domClass.add(this.btnLogout, "w3-disabled");

            this.addSubscription("/Session/Open", lang.hitch(this, this._onOpenSession));
        }

        this.hasUserRole("_DEV", lang.hitch(this, function (bool) {
            this.hideNode(this.sectionDeveloper, !bool);
        }));

        on(this.domNode, "click", lang.hitch(this, function (evt) { evt.stopPropagation(); }))
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        
        this.show();
    }
}

export default mdsWidget(LoginPopupForm);